"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _util = require("@bento-core/util");
var _RoleBadgeGroup = _interopRequireDefault(require("./RoleBadgeGroup"));
var _defaultStyle = _interopRequireDefault(require("./defaultStyle"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var HeaderView = function HeaderView(_ref) {
  var classes = _ref.classes,
    data = _ref.data,
    imageMap = _ref.imageMap;
  if (!data || !data.getMyUser) {
    return /*#__PURE__*/_react.default.createElement(_core.Alert, {
      severity: "error"
    }, "Provide Valid User Information.");
  }
  var icon;
  var role = data.getMyUser.role;
  if (role && role.length && Object.prototype.hasOwnProperty.call(imageMap, role)) {
    icon = imageMap[role];
  } else {
    icon = imageMap.member;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.profile_header_container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.profile_header_left
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.profile_header_icon
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: classes.profileIcon,
    src: icon.src,
    alt: icon.alt
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.profile_header_right
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.profile_header_text
  }, (0, _util.capitalize)(data.getMyUser.email)), /*#__PURE__*/_react.default.createElement(_RoleBadgeGroup.default, {
    data: data.getMyUser
  }))));
};
var _default = (0, _core.withStyles)(_defaultStyle.default)(HeaderView);
exports.default = _default;